import React from 'react';
import { findbrandvoiceContent } from '../rich-content/findbrandvoice-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const FindbrandvoiceDetailPage = () => {
  return <AutomaticPageBuilder content={findbrandvoiceContent} />;
};

export default FindbrandvoiceDetailPage;
